"use client";

import { AnygiftButton } from "@/components/domains/anygift";
import { useInitAnygift } from "@/utils/hooks";

export interface AnygiftSectionProps {
  loadScript?: boolean;
  productName: string;
}

export function AnygiftSection({
  productName,
  loadScript = true,
}: AnygiftSectionProps): React.ReactNode {
  useInitAnygift(loadScript);

  return <AnygiftButton type="products" productCode={`subscription/${productName}`} />;
}
